import { CONTRACT_NAME } from "../config";
import { getWalletSession } from "./wallet_functions";

export const get_ingredient_count = (data) => {
    let tokens = data.fungible_prices.prices.length;
    let nfts = data.nft_prices.prices.length;
    let proofs = data.required_proof_nfts.length;

    return tokens + nfts + proofs;
}

export const deleteListing = async (listing_id, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay, setRefresh) => {
    setEnterModalDisplay('');
    setEnterModalText('Awaiting confirmation...');
    let walletSession = await getWalletSession(setEnterModalText);
    let session = walletSession[0];
    let this_user = walletSession[1];
    let this_permission = walletSession[2];


    try {   
      let actions = [
        {
            account: CONTRACT_NAME,
            name: "rmvlisting",
            authorization: [
              {
                actor: this_user,
                permission: this_permission,
              },
            ],
            data: {
                listing_id: listing_id,
            },
          },
      ]

      const response = await session[0].signTransaction({
        actions: actions
      }, {
  
        blocksBehind: 3,
        expireSeconds: 1200,
        broadcast: true,
      })
      setLoadingDisplay('');
      setEnterButtonsDisplay('hidden');
      setEnterModalText('Processing your transaction...')
      const timer = setTimeout(() => {
        
          setEnterModalText('Your listing has been deleted');
          setLoadingDisplay('none');
          setEnterButtonsDisplay('');
          setRefresh((prev) => prev + 1);
    
      }, 2000);
      return () => clearTimeout(timer);
  
    } catch(e) {
      setEnterModalText(JSON.stringify(e.message));
      console.log(e)
      
    }
 
  }